import React from 'react';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import { useNavigate } from 'react-router-dom';

export default function BackButton({
    onClickExtra,
    counter,
}: {
    counter?: number;
    onClickExtra?: () => void;
}) {
    const navigate = useNavigate();

    const handleClick = () => {
        if (onClickExtra !== undefined) {
            onClickExtra(); // Call the onClickExtra function
        }
        navigate(counter ? -counter : -1);
    };

    return (
        <div
            className="cursor-pointer text-true-blue py-8 w-28"
            onClick={handleClick}
        >
            <ArrowBackIosIcon /> Go back
        </div>
    );
}
